import React,{useState} from "react"
import Container from "@material-ui/core/Container"
import {makeStyles} from "@material-ui/core/styles"
import TextField from "@material-ui/core/TextField"
import {connect} from "react-redux"
import { Grid} from "@material-ui/core"
import * as actions from "../store/action/index"
import Spinner from "../UI/Spinner/spinner"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import Fukoimg from "../demo/signup.jpg"
const useStyles = makeStyles((theme)=>({
    background:{
        backgroundColor:"darkslateblue",
        fontFamily:[
            'Luckiest Guy', "cursive"
               ],
    
        paddingTop:"7%",
        color:"white",
    },
    load:{
      textAlign:"center",
      fontFamily:[
        'Luckiest Guy', "cursive"
           ],
    color:"red"
    },
    root: {
        '& > *': {
          margin: theme.spacing(1),
          width: '35ch',
    
        },
        color:"white",
        borderColor:"white",

    
      textAlign:"right",
      marginLeft:"0px"
      },
          margin:{
              marginBottom:"30%",
              textAlign:"right"
          },
          imghandle:{
              width:"90%",
              height:"40%",
             borderRadius:"12px",
         
             transform:"scaleX(-1)"
          }       ,
          marign:{
              marginBottom:"56px",
              fontFamily:[
                'Luckiest Guy', "cursive"
                
                   ],
      
            },

            color:{
          color:"white",
          
            },

            button:{
              padding:"1%",
              fontFamily:[
                'Luckiest Guy', "cursive"
                   ],
          
                  },
            
    }))

const signUp=(props)=>{
const [email , setEmail] = useState("")
const [password , setPassword] = useState("")
const [sign , setSignup] = useState(true)
  const emailChangeHandler=(event)=>{
  setEmail(event.target.value)
  }
  const passwordChangeHandler=(event)=>{
    setPassword(event.target.value)
  }
  const submitChangeHandler=(event)=>{
  event.preventDefault()
    console.log("activate"  )
    console.log(email)
    console.log(password)
    props.onAuth(email , password , sign)
  }

  const signupHandler=()=>{
    setSignup(!sign)
  }

  const classes = useStyles()

  let formSubmit = <Button color="secondary" type="submit" variant="contained" className={classes.button}>{sign ? "Signup" : "Login" }</Button>
 
  if (props.loading){
    formSubmit = <div className={classes.load}><Spinner/></div>
  }
  let errorMessage = null
  if (props.error){
    errorMessage = <Typography variant="h4" color="red" className={classes.load}> {props.error.message} </Typography>
  }

  
    return(
        <Container maxWidth="xl" className={classes.background}>
      <Grid container > 
            <Grid item md="6" xs="5" className={classes.margin}>
                  
                  <Typography  variant="h3" className={classes.marign} >Join Me Onee Chan</Typography>
                        
                        {errorMessage}

                          <form   onSubmit={submitChangeHandler} className={classes.root} noValidate  autoComplete="off" >  <br/>
                          <TextField  id="outlined-basic"
                          label="Email Address"
                            variant="outlined"
                            onChange={emailChangeHandler}
                            className={classes.color}
                          />
                          <br />
                          <TextField id="outlined-basic"
                          label="Password"
                            variant="outlined"
                            type="password"
                            className={classes.color}
                            onChange={passwordChangeHandler}  
                            /> <br />                          
                        {formSubmit}
                          </form>            
                        <Button className={classes.button} onClick={signupHandler} color="secondary" variant="contained">Switch to {sign?"LOGIN" : "SIGNUP  "}</Button>
   
            </Grid>
            <Grid item md="4" xs="7">
            <img src={Fukoimg} alt="sign_up img" className={classes.imghandle}  />
            </Grid>
            </Grid>
            </Container>
    )
}

const mapStateToProps=state=>{
  return{
    loading:state.auth.loading,
    error:state.auth.error
  }
}

const mapDispatchToProps=dispatch=>{
 return{
   onAuth:(email,password,isSignup) => dispatch(actions.auth(email,password,isSignup))
 }
}

export default connect(mapStateToProps , mapDispatchToProps)(signUp)


// WEBPACK FOOTER //
// ./src/Authentication/Signup.jsx